import React, { useMemo } from 'react';
import { MaybeWrapper } from "../../../../../helper/components/MaybeWrapper.js";
import { Button, ButtonIconLayout } from "../../../../button/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function FooterButton({
  action,
  label,
  forceTextButton = false,
  small
}) {
  const variant = useMemo(() => {
    if (forceTextButton) {
      return 'text';
    }
    return action.semantic === 'PRIMARY' || action.semantic === 'SUBMIT' ? undefined : 'outlined';
  }, [action.semantic, forceTextButton]);
  return /*#__PURE__*/_jsx(Button, {
    ...(action.buttonProps ?? {}),
    // Typecast needed because of TS issues with variant union
    variant: variant,
    iconLeft: variant === 'text' ? action.icon : undefined // Typecast needed because of TS issues with variant union
    ,
    onClick: () => action.handler?.(),
    disabled: action.disabled,
    loading: action.loading ?? false,
    // Typecast needed because of TS issues with variant union
    type: action.semantic === 'SUBMIT' ? 'submit' : 'button',
    form: action.form,
    small: small,
    children: /*#__PURE__*/_jsx(MaybeWrapper, {
      condition: !!action.icon && variant !== 'text',
      wrapper: content => /*#__PURE__*/_jsx(ButtonIconLayout, {
        icon: action.icon,
        iconPlacement: "LEADING",
        children: content
      }),
      children: label
    })
  });
}